import { useInstallPrompt } from './useInstallPrompt'
import { useFullscreen }    from './useFullscreen'

const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

export function DisplaySetupPage() {
  const { deferredPrompt, isInstalled, promptInstall } = useInstallPrompt()
  const { isFullscreen, enter: enterFs, supported: fsSupported } = useFullscreen()

  const isDisplayModeFull = window.matchMedia('(display-mode: fullscreen)').matches
  const showFsBtn         = fsSupported && !isDisplayModeFull && !isFullscreen
  const showInstallBtn    = !isInstalled && deferredPrompt !== null
  const showIOSHint       = !isInstalled && isIOS

  return (
    <div className="fixed inset-0 bg-[#0d0d1a] flex flex-col items-center justify-center px-8 text-center">
      <div className="w-16 h-16 bg-violet-600 rounded-2xl flex items-center justify-center text-white text-3xl font-bold mb-8">
        D
      </div>
      <h1 className="text-white text-2xl font-bold mb-4">Wall Display Setup</h1>
      <p className="text-gray-400 text-lg leading-relaxed max-w-sm">
        To set up wall display mode, open DoorChart on any family member's device,
        go to <strong className="text-white">Settings → Wall Display</strong>, and
        register this tablet as a display device.
      </p>
      <p className="text-gray-600 text-sm mt-4">
        Then scan the QR code or visit the provided URL on this device.
      </p>

      {/* Fullscreen / install prompts */}
      {(showFsBtn || showInstallBtn || showIOSHint) && (
        <div className="mt-10 w-full max-w-sm space-y-3">
          <p className="text-gray-600 text-xs uppercase tracking-wider mb-4">For the best experience</p>

          {showFsBtn && (
            <button
              onClick={enterFs}
              className="w-full bg-white/5 hover:bg-white/10 active:bg-white/15 text-white border border-white/10 rounded-xl px-4 py-3 flex items-center gap-3 transition-colors"
            >
              <svg className="w-5 h-5 text-violet-400 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/>
              </svg>
              <span className="text-left">
                <span className="block text-sm font-semibold">Enter fullscreen now</span>
                <span className="block text-gray-500 text-xs mt-0.5">Fill the entire screen</span>
              </span>
            </button>
          )}

          {showInstallBtn && (
            <button
              onClick={promptInstall}
              className="w-full bg-violet-600 hover:bg-violet-500 active:bg-violet-700 text-white rounded-xl px-4 py-3 flex items-center gap-3 transition-colors"
            >
              <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 16l-4-4m4 4 4-4m-4 4V4"/><path d="M20 21H4"/>
              </svg>
              <span className="text-left">
                <span className="block text-sm font-semibold">Install DoorChart</span>
                <span className="block text-white/60 text-xs mt-0.5">Automatic fullscreen on every launch</span>
              </span>
            </button>
          )}

          {showIOSHint && (
            <div className="bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-left">
              <p className="text-white text-sm font-semibold mb-1">Add to Home Screen</p>
              <p className="text-gray-400 text-xs leading-relaxed">
                In Safari, tap the <span className="text-white font-semibold">Share</span> button{' '}
                then <span className="text-white font-semibold">Add to Home Screen</span>.
                Opening the app icon gives fullscreen mode automatically.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
